import { Button } from 'react-bootstrap';
import '../../Assets/scss/components/sidebar.scss';
import DashboardLogo from '../DashboardLogo';
import aioaLogo from "../../Assets/img/all-in-one-accessibility-logo.svg";
import DomainPlanInfo from '../DomainPlanName';
import DashboardSidebarNavigation from '../SidebarNavigation';
import TourGuide from '../TourGuide';
import aioaLogoLight from "../../Assets/img/all-in-one-accessibility-logo-light.svg";
import { useTheme } from '../../Context/ThemeContext';

interface PropTypes {
    mobileMenu: boolean, // flag for mobile menu
    handelMobileMenu: Function, // function to handle mobile menu
    handelCloseMobileMenu: Function, // function to flag close mobile menu
}

// component to render dashboard sidebar menu
const DashboardSidebarMenu = (props: PropTypes) => {

    const { mobileMenu, handelMobileMenu, handelCloseMobileMenu } = props;

    const {theme} = useTheme()
        
    return (
        <>
        <TourGuide />
            <aside className={`aioa_dashboard-sidebar ${mobileMenu ? `active` : ``}`}>
                <div className='aioa_dashboard-sidebar-close-btn d-xxl-none'>
                    <Button variant='danger' className='btn-close' onClick={() => handelMobileMenu()}></Button>
                </div>
                <div className='aioa_dashboard-sidebar-logo'>
                    <img src={theme === 'dark' ? aioaLogoLight : aioaLogo} alt="All in One Accessibility Logo" />
                    <DomainPlanInfo />
                </div>
                <div className='aioa_dashboard-sidebar-navigation tour-sidebar'>
                    <DashboardSidebarNavigation handelMobileMenu={handelCloseMobileMenu} />
                </div>
            </aside>
        </>
    )
}

export default DashboardSidebarMenu;